export default __webpack_public_path__ + "static/media/successIcon.815a6eb0.svg";